import { concatLogsAndVars, createEmptyLogsAndVars, dwReportError, recordVariable, ReportingError, } from "../../utils/diagnostics/clientErrors";
import { sendMessageWithMpcWallet } from "../../utils/dwclient/dwcommonutils";
import { storeRefreshToken } from "../../utils/dwclient/localstorage/jwtStorage";
const apiVersion = process.env.API_VERSION || "1.0";
export async function createAuthToken(clientId, clientSessionToken, userSharesString) {
    let logsAndVars = createEmptyLogsAndVars("createAuthToken:createAuthToken");
    recordVariable(logsAndVars, "portalClientId (param)", clientId);
    recordVariable(logsAndVars, "clientSessionToken (param)", clientSessionToken);
    if (clientSessionToken === null) {
        throw new ReportingError("clientSessionToken is null", logsAndVars);
    }
    const sendObject = {
        method: "get",
        endpoint: `/api/${apiVersion}/auth/token`,
        clientId: clientId,
    };
    const multiUserShares = JSON.parse(userSharesString ?? "");
    recordVariable(logsAndVars, "sendObject", sendObject);
    try {
        const response = await sendMessageWithMpcWallet(clientSessionToken, multiUserShares.ED25519.share, sendObject);
        if (response.refreshToken) {
            storeRefreshToken(response.refreshToken);
        }
        return response.authToken;
    }
    catch (error) {
        if (error?.cause?.response?.status === 500 || error?.cause?.cause?.response?.status === 500) {
            return undefined;
        }
        if (error instanceof ReportingError) {
            logsAndVars = concatLogsAndVars(logsAndVars, error.logsAndVars);
        }
        dwReportError(null, clientId, error, logsAndVars);
        throw new ReportingError("Creating auth token has failed. Error message was: " + error.message, logsAndVars);
    }
}
/*export async function createAuthToken(
  walletAddress: string,
  clientId: string,
  clientSessionToken: string | null,
  userSharesString: string,
) {
  let logsAndVars: LogsAndVarsType = createEmptyLogsAndVars("createAuthToken:createAuthToken");
  recordVariable(logsAndVars, "walletAddress (param)", walletAddress);
  recordVariable(logsAndVars, "clientId (param)", clientId);
  try {
    const authMsg = "This is the authorization message to sign.";
    recordVariable(logsAndVars, "authMsg", authMsg);
    clientSessionToken = await ensureValidClientSessionToken(walletAddress, clientId, clientSessionToken);
    recordVariable(logsAndVars, "clientSessionToken", clientSessionToken);
    //const userSharesString = await loadUserShares();
    recordVariable(logsAndVars, "userSharesString", userSharesString);
    const multiUserShares: MpcWalletUserShares = JSON.parse(userSharesString ?? "");
    const signedAuthMsg = await mpcSign(clientSessionToken, multiUserShares.ED25519.share, authMsg);
    recordVariable(logsAndVars, "signedAuthMsg", signedAuthMsg);
    const jwt = await requestNewJWTToken(authMsg, signedAuthMsg);
    recordVariable(logsAndVars, "jwt", jwt);
    return jwt;
  } catch (error: any) {
    if (error instanceof ReportingError) {
      logsAndVars = concatLogsAndVars(logsAndVars, error.logsAndVars);
    }
    dwReportError(walletAddress, clientId, error, { logsAndVars });
    throw new ReportingError(error, logsAndVars);
  }
}

async function ensureValidClientSessionToken(
  walletAddress: string,
  clientId: string,
  clientSessionToken: string | null,
) {
  if (clientSessionToken !== null) {
    const isValid = await isClientSessionTokenValid(clientSessionToken);
    if (isValid) {
      return clientSessionToken;
    }
  }
  const clientSessionTokenHolder = await refreshClientSessionToken(window.ethereum, walletAddress, clientId, "0.3");
  clientSessionToken = clientSessionTokenHolder.clientSessionToken;
  return clientSessionToken;
}

async function requestNewJWTToken(authMsg: string, signedAuthMsg: any) {
  const logsAndVars: LogsAndVarsType = createEmptyLogsAndVars("create_auth_token:requestNewJWTToken");
  try {
    const baseUrl =
      //process.env.DWINITY_BACKEND_FOR_REQUEST_JWT_TOKEN_CHECK ??
      process.env.DWINITY_BACKEND ?? "https://api.dev.dwinity.com";
    const myApiVersion = "0.3";
    const url = `${baseUrl}/api/${myApiVersion}/auth/token`;
    recordVariable(logsAndVars, "url", url);
    recordVariable(logsAndVars, "authMsg (query param)", authMsg);
    recordVariable(logsAndVars, "signedAuthMsg (query param)", signedAuthMsg);
    const response: AxiosResponse<RequestJWTTokenResponse> = await axios.get(url, {
      params: {
        authMsg: authMsg,
        signature: signedAuthMsg,
      },
      headers: {
        "Content-Type": "application/json",
      },
    });
    recordVariable(logsAndVars, "response", response);
    return response.data.authToken;
  } catch (error: any) {
    await recordPotentialAxiosError(logsAndVars, error);
    throw new ReportingError(error, logsAndVars);
  }
}
*/
